import React, { useEffect, useState } from 'react';

import useTranslate from '../../../../common/hooks/useTranslate';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { acceptAgreements, getAgreement } from '../../../services/agreementService';
import { returnPdf } from '../../../services/documentsService';

import { POPUP } from '../../../../redux/types';
import { pdfjs } from 'react-pdf';

import { IAgreementPdfPage } from '../../types/IAgreementPdfPage';
import { IAgreement } from '../../types/IAgreement';
import { IFile } from '../../../pdfPage/types/IFile';


import Logo from '../../../ui/logo/logo';
import Button from '../../../ui/button/button';
import PdfViewer from '../../../pdfPage/components/pdfViewer/pdfViewer';
import ComponentLoader from '../../../ui/loaders/componentLoader/componentLoader';

import './agreementPdfPage.scss';

// TODO: Move Worker into Local File
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const AgreementPdfPage: React.FC<IAgreementPdfPage> = ({ setShowAgreement }) => {
  const [file, setFile] = useState<IFile>({ uint8: '', blob: '' });
  const [loading, setLoading] = useState<boolean>(true);
  const [agreement, setAgreement] = useState<IAgreement>({
    id: 0,
    name: '',
    appId: '',
    appName: '',
    version: '',
    date: '',
    documentName: '',
    inactive: true,
    content: '',
    contentType: '',
  });

  const { t } = useTranslate();
  const dispatch = useDispatch();
  const location = useLocation();
  let { assignId } = useParams();
  let navigate = useNavigate();

  const dataItem = location.state;

  useEffect(() => {
    Promise.all([getAgreement(assignId), returnPdf(`/Users/agreements/${assignId}/download`)]).then((res: any[]) => {
      setAgreement(res[0].data);
      setFile(res[1]);
      setLoading(false);
    }).catch((err) => {
      dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
      setLoading(false);
    });
  }, [assignId]);

  const accept = () => {
    acceptAgreements(assignId).then(() => {
      if (setShowAgreement !== undefined) {
        setShowAgreement(false);
        navigate('/');
      }
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  };

  const reject = () => {
    navigate('/agreements/declined');
  };

  return (
    <div className={'agreement-pdf-page'}>
      {loading ? (
        <ComponentLoader />
      ) : (
        <>
          <div className='agreement-content'>
            <div className='agreement-header'>
              <div className='logo'>
                <Logo logoSource='/branding/logo.png' />
              </div>
            </div>
            <h1 className='agreement-title'>{agreement.name}</h1>
            {!dataItem && (
              <div className='buttons-group'>
                <div className='buttons'>
                  <Button buttonStyle='button-wrapper button-wrapper-square accept-button'
                          handleClick={() => accept()}>
                    {t('AGREEMENTS.ACCEPT')}
                  </Button>
                  <Button buttonStyle='button-wrapper button-wrapper-square reject-button'
                          handleClick={() => reject()}>
                    {t('AGREEMENTS.DECLINE')}
                  </Button>
                </div>
              </div>
            )}
            <PdfViewer
              shouldPin={false}
              id={assignId}
              loading={loading}
              file={file}
              title={false}
              controlsBcgColor={'white'}
              className={'pdfDocument-container-agreements'}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default AgreementPdfPage;
